import { render, staticRenderFns } from "./TablaInformativaAdicionales.vue?vue&type=template&id=56306963&scoped=true"
import script from "./TablaInformativaAdicionales.vue?vue&type=script&lang=js"
export * from "./TablaInformativaAdicionales.vue?vue&type=script&lang=js"
import style0 from "./TablaInformativaAdicionales.vue?vue&type=style&index=0&id=56306963&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56306963",
  null
  
)

export default component.exports